class CookieReader {
    constructor() {
        this._refresh();
    }

    /**
     * Refresh the cookies values
     * @private
     */
    _refresh() {
        this.cookie = {};
        document.cookie.split(';').forEach((cookie) => {
            let a = cookie.split('=');
            this.cookie[a[0].replace(/^\s*/, '')] = decodeURIComponent(a[1]);
        })
    }

    /**
     * Get the value decoded from the cookies
     * @param {string} name
     * @returns {*}
     */
    get(name) {
        this._refresh();
        return this.cookie[name];
    }

    /**
     * Check if a cookie exists
     * @param {string} name
     * @returns {boolean}
     */
    exists(name) {
        this._refresh();
        return this.cookie.hasOwnProperty(name);
    }

    /**
     * Delete a cookie
     * @param name
     */
    forget(name) {
        if (this.exists(name)) {
            document.cookie = name + "=; expires=" + (new Date()).toString() + ';'
        }
    }
}

export default new CookieReader();